import React from 'react'

const withContainer = Component => props => {

  return (
    <Component />
  )
}

export default withContainer
